import React from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Holdings } from '../../../../../Holdings/Holdings';

export const HoldingsTab = () => {
  return (
    <Box
      css={`
        margin-left: ${({ theme }) => theme.space[24] * -1}px;
        margin-right: ${({ theme }) => theme.space[24] * -1}px;
      `}
    >
      <Holdings />
    </Box>
  );
};
